/** Синхронно с api/utils/employee_positions.POSITION_DESK_SLUG */
const POSITION_DESK_SLUG: Record<string, string> = {
  Admin: 'admin',
  Manager: 'manager',
  ProjectLaunchSpecialist: 'project-launch',
  Google: 'google',
  Facebook: 'facebook',
  Asistent: 'asistent',
  Control: 'control',
  Accounter: 'accounter',
  Zam: 'zam',
  OperationalDirector: 'operational-director',
  SEO: 'seo',
  Designer: 'designer',
  DataAnalyst: 'data-analyst',
}

export function positionDeskSlug(normalized: string | null | undefined): string {
  if (!normalized) return 'staff'
  return (
    POSITION_DESK_SLUG[normalized] ||
    String(normalized)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-') || 'staff'
  )
}

export function employeeDeskPath(employeeId: string, normalized: string | null | undefined): string {
  void employeeId
  void normalized
  return '/employee/home'
}

/** HTML employee dashboards (FastAPI), not React under /employee/desk — need full page navigation */
export function isEmployeeHtmlDashboardPath(path: string | null | undefined): boolean {
  const p = String(path || '').trim()
  if (p === '/employee/home?legacy=1') return true
  if (p === '/seo_home' || p.startsWith('/seo_home/')) return true
  return p.startsWith('/employee/home/') && p !== '/employee/home'
}

/** Jinja/HTML главные вне React Router — нужен window.location, не <Navigate> */
export function isEmployeeHardNavHomePath(path: string | null | undefined): boolean {
  const p = String(path || '').trim()
  return (
    isEmployeeHtmlDashboardPath(p) ||
    p === '/seo_home' ||
    p.startsWith('/seo_home/') ||
    p === '/assistant/home' ||
    p === '/home_asist' ||
    p.startsWith('/assistant/') ||
    p.startsWith('/home_asist/')
  )
}

export type DeskUserLike = {
  desk_path?: string | null
  employee_id?: string | null
  id?: string | null
  normalized_position?: string | null
  normalized_positions?: string[] | null
  role?: string | null
}

/** Главная SPA сотрудника: приоритет серверного desk_path из /api/auth/me */
export function employeeHomeHref(user: DeskUserLike | null | undefined): string {
  if (!user) return '/employee/home'
  if (String(user.role || '').trim().toLowerCase() === 'admin') return '/admin'
  if (String(user.normalized_position || '').trim() === 'Asistent') return '/employee/home?legacy=1'
  return '/employee/home'
}
